<template>
  <div :class="$style.box">
    <div :class="$style.content">
      <div :class="$style.top">
        <p :class="$style.name">关注{{ officialInfo.official_account_name }}</p>
        <p :class="$style.tip">福利资讯、官方活动一手掌握</p>
        <i :class="[$style.close, 'iconfont', 'yw-guanbi1']" @click="$emit('close')"></i>
      </div>
      <div :class="$style.info">
        <div :class="$style.way">
          <span :class="$style.title">方式一</span>
          <div :class="$style.word">
            <p>
              复制微信码(<span>{{ officialInfo.official_account }}</span
              >)
            </p>
            <p>微信搜索公众号关注。</p>
          </div>
          <div :class="`${$style.btn} copyBtn`" data-clipboard-target="#copy" @click="pointReport">点击复制</div>
        </div>
        <div :class="$style.way">
          <span :class="$style.title">方式二</span>
          <p :class="$style.word">{{ methodTip }}</p>
        </div>
      </div>
      <div :class="$style.code">
        <img :class="$style.left" :src="`${$cdnLink}/wanXin/orangeTheme/figure_1.png`" alt />
        <img :class="$style.codeItem" :src="officialInfo.official_qr_code_url" alt />
        <img :class="$style.right" :src="`${$cdnLink}/wanXin/orangeTheme/figure_2.png`" alt />
      </div>
      <input type="text" :class="$style.copyInput" id="copy" readonly :value="officialInfo.official_account" />
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { mapState } from 'vuex';
import { officialAccount } from '@/api/user';
import { isAndroid } from '@/libs/utils.js';

export default {
  data() {
    return {
      cdnUrl: '//sdk-static.zhangyuqu.com/Lianyun/h5sdkv2'
    };
  },
  mounted() {
    this.$store.dispatch('global/getOfficialInfo');
    this.copyInit();
  },
  computed: {
    ...mapState({
      officialInfo: state => state.global.officialInfo,
      userState: state => state.user
    }),
    methodTip() {
      return isAndroid() ? '手机截屏保存图片，微信扫码关注公众号' : '点击下方二维码，长按保存，微信扫码关注公众号';
    }
  },
  methods: {
    copyInit() {
      this.copy = new Clipboard('.copyBtn');
      this.copy.on('success', e => {
        this.$toast('复制成功');
      });
    },
    pointReport() {
      officialAccount({
        user_id: this.userState.user_id,
        access_token: this.userState.access_token,
        appkey: this.userState.appkey,
        official_templet_id: this.officialInfo.official_templet_id,
        type: 1
      });
    }
  }
};
</script>

<style lang="scss" module>
.box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 417px;
    height: 289px;
    border-radius: 8px;
    margin: auto;
    overflow: hidden;
    background-image: url('#{$cdn-url}/wanXin/orangeTheme/officialBack.png');
    background-size: 100% 100%;
    @media screen and (orientation: portrait) {
      width: 345px;
    }
    .top {
      font-size: 16px;
      position: relative;
      .name {
        font-weight: bold;
        line-height: 34px;
        color: #ffffff;
        text-align: center;
        height: 34px;
      }
      .tip {
        color: #fb5d56;
        font-size: 12px;
        text-align: center;
        line-height: 26px;
        height: 26px;
      }
      .close {
        position: absolute;
        width: 20px;
        top: 8px;
        right: 5px;
        color: #ffffff;
      }
    }
    .copyInput {
      position: absolute;
      top: -1000px;
    }
    .code {
      position: absolute;
      bottom: 10px;
      width: 100%;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      .codeItem {
        width: 90px;
        height: 90px;
        margin: 0 10px;
      }
      .left, .right {
        height: 108px;
      }
    }
    .info {
      display: flex;
      justify-content: space-around;
      font-size: 11px;
      width: 100%;
      .way {
        width: 130px;
        text-align: center;
        color: #fb5d56;
        margin-top: 10px;
        .title {
          display: inline-block;
          font-size: 13px;
          font-weight: bold;
          position: relative;
          margin-bottom: 5px;
          &:before {
            position: absolute;
            content: ' ';
            top: 4px;
            left: -14px;
            width: 5px;
            height: 5px;
            background: #fb5d56;
            opacity: 0.69;
            transform: rotate(45deg);
          }
          &:after {
            position: absolute;
            content: ' ';
            top: 4px;
            right: -14px;
            width: 5px;
            height: 5px;
            background: #fb5d56;
            opacity: 0.69;
            transform: rotate(45deg);
          }
        }
        .word {
          line-height: 14px;
          span {
            color: #ff1d13;
            font-weight: bold;
          }
        }
        .btn {
          margin: auto {
            top: 5px;
          }
          width: 58px;
          height: 18px;
          color: #ffffff;
          background: #ffcc5e;
          border-radius: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 9px;
        }
      }
    }
  }
}
</style>
